var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77489 15.2957C2.92496 14.1915 2.5 13.6394 2.5 12C2.5 10.3606 2.92496 9.80853 3.77489 8.70433C5.47196 6.49956 8.31811 4 12.5 4C16.6819 4 19.528 6.49956 21.2251 8.70433C22.075 9.80853 22.5 10.3606 22.5 12C22.5 13.6394 22.075 14.1915 21.2251 15.2957C19.528 17.5004 16.6819 20 12.5 20C8.31811 20 5.47196 17.5004 3.77489 15.2957Z",
    stroke: "#666D80",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 13.6569 14.1569 15 12.5 15C10.8431 15 9.5 13.6569 9.5 12C9.5 10.3431 10.8431 9 12.5 9C14.1569 9 15.5 10.3431 15.5 12Z",
    stroke: "#666D80",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.de0ba5d78a19de6fa8db956971fc532f.svg";
export { ForwardRef as ReactComponent };